export const resolveSafeReturnPage = (returnPage, entryUrl) => {
    if (!returnPage || !entryUrl) return ''
    try {
        const target = new URL(returnPage)
        const entry = new URL(entryUrl)
        if (target.protocol !== 'https:' || target.origin !== entry.origin) return ''
        const basePath = entry.pathname.replace(/\/+$/, '') || '/'
        const targetPath = target.pathname.replace(/\/+$/, '') || '/'
        if (targetPath !== basePath && !targetPath.startsWith(`${basePath}/`)) return ''
        return target.toString()
    } catch (error) {
        return ''
    }
}

